var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite",class:{ 'favorite--favorite': _vm.isFavorite },on:{"click":function($event){return _vm.$emit('toggle-favorite')}}},[(_vm.isFavorite)?_c('HeartFilled',{staticClass:"icon"}):_c('Heart',{staticClass:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }